import React from 'react';
import { BookOpenIcon, FolderOpenIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 tomos completos'
}, {
  icon: GiftIcon,
  label: '5 bonos estratégicos'
}, {
  icon: FolderOpenIcon,
  label: '+300 recursos listos para usar'
}, {
  icon: UsersIcon,
  label: 'Docentes, estudiantes y profesionales'
}];
export function SocialProof() {
  return <section className="border-y border-slate-300/20 bg-blue-900 py-5" aria-label="Contenido del Megapack" data-id="element-223" data-mp="3ebmjbaalryk">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-slate-100 sm:justify-between" data-id="element-224" data-mp="8e7rbcqtdnf6">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-225" data-mp="3ushfbkqu0tff">
            <Icon className="h-5 w-5 text-slate-300" aria-hidden="true" data-id="element-226" data-mp="md7f6i6i5yaa" /> {label}
          </span>)}
      </div>
    </section>;
}